import type { IComponentController, IScope } from "angular";

import { isNil } from "lodash";
import type { IAction } from "App/Modules/Gui/Components/ActionMenu/IAction";
import type { IResponseWithLoading } from "App/Modules/Models/Models/IResponseWithLoading";

export class ActionMenuComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public isOpen: boolean;

    public actions: IAction[];

    constructor(private readonly scope: IScope) {}

    public $onInit() {
        this.actions
            .filter((action) => action.click)
            .forEach((action) => {
                const originalHandler = action.click;
                const wrapper = (event: any) => {
                    originalHandler(event);

                    if (isNil(action.response)) {
                        this.isOpen = false;
                    } else {
                        const unsub = this.scope.$watch(
                            () => action.response(),
                            (response: IResponseWithLoading<any>) => {
                                if (isNil(response) || response.isLoading) {
                                    return;
                                }

                                this.isOpen = false;
                                unsub();
                            },
                        );
                    }
                };

                action.click = wrapper;
            });
    }
}
